/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, warp-drive/no-legacy-request-patterns */
import Person from '@linc-technologies/linced-common/models/person';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import type { Type } from '@warp-drive/core/types/symbols';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import type School from '@linc-technologies/linced-common/models/school';
import type OptionsService from '@linc-technologies/linced-common/services/options';
import type StoreService from '@linc-technologies/linced-common/services/store';

// Proto: people.Person.
export default class _Person extends Person {
  declare [Type]: 'person';

  @service('options')
  declare optionsSvc: OptionsService;

  @service
  declare store: StoreService;

  @computed(
    'type',
    'homeroom.label',
    'fields.parents:classPlacements:showClassInProfileInformation.value',
  )
  get bannerText() {
    if (this.type === PersonType.LEARNER) {
      const school = this.store.peekRecord<School>('school', this.school_id);
      if (
        this.optionsSvc.schoolGet(
          school,
          'parents:classPlacements:showClassInProfileInformation',
        )
      ) {
        return this.get('homeroom.label') as string;
      }
    }

    return '';
  }
}
